import React from 'react';
import './english.css';
import { Link } from 'react-router-dom';

function EnglishCourse() {
  return (
    <div className="english-course">
      <header className="course-header">
        <div className="header-overlay">
          <h1>English Language Mastery Program</h1>
          <p className="subtitle">Develop Fluency, Confidence, and Cultural Understanding</p>
        </div>
      </header>

      <section className="course-overview">
        <div className="container">
          <h2>Program Overview</h2>
          <div className="overview-grid">
            <div className="overview-card">
              <div className="icon">🗣️</div>
              <h3>Speaking & Pronunciation</h3>
              <p>Master conversational English with native-like pronunciation and intonation.</p>
            </div>
            <div className="overview-card">
              <div className="icon">✍️</div>
              <h3>Writing Excellence</h3>
              <p>Develop academic, business, and creative writing skills.</p>
            </div>
            <div className="overview-card">
              <div className="icon">🌍</div>
              <h3>Cultural Context</h3>
              <p>Understand English through literature, media, and cultural studies.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="levels-section">
        <div className="container">
          <h2>Course Levels</h2>
          <div className="levels-container">
            <div className="level-card beginner">
              <h3>Beginner (A1-A2)</h3>
              <ul>
                <li>Basic vocabulary and grammar</li>
                <li>Simple conversations</li>
                <li>Everyday English</li>
              </ul>
            </div>
            <div className="level-card intermediate">
              <h3>Intermediate (B1-B2)</h3>
              <ul>
                <li>Complex sentence structures</li>
                <li>Workplace communication</li>
                <li>Media comprehension</li>
              </ul>
            </div>
            <div className="level-card advanced">
              <h3>Advanced (C1-C2)</h3>
              <ul>
                <li>Academic writing</li>
                <li>Nuanced expression</li>
                <li>Professional fluency</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="features-section">
        <div className="container">
          <h2>Unique Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎭</div>
              <h3>Drama Techniques</h3>
              <p>Improve fluency through role-play and theater methods.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💻</div>
              <h3>Digital Learning</h3>
              <p>Interactive online platform with AI pronunciation analysis.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📚</div>
              <h3>Book Club</h3>
              <p>Read and discuss contemporary and classic literature.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎤</div>
              <h3>Debate Society</h3>
              <p>Develop critical thinking and persuasive speaking skills.</p>
            </div>
          </div>
        </div>
      </section>

    

      <section className="enrollment-cta">
        <div className="container">
          <h2>Start Your English Journey Today</h2>
          <p>New sessions begin monthly. Take our free placement test to find your perfect level.</p>
          <div className="cta-buttons">
            <Link to="/apply" className="cta-button primary">Apply Now</Link>
            <Link to="/contactus" className="cta-button secondary">Contact an Advisor</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default EnglishCourse;